import { useState } from 'react';

interface VideoCardProps {
  id: string;
  title: string;
  category: string;
  image: string;
  duration: string;
  rating: string;
  tags: string[];
  updateTime: string;
  featured?: boolean;
  onClick: (id: string) => void;
}

const categoryNames: Record<string, string> = {
  dianying: '电影',
  dianshiju: '电视剧',
  zongyi: '综艺',
  jilupian: '纪录片',
  dongman: '动漫',
};

export default function VideoCard({
  id,
  title,
  category,
  image,
  duration,
  rating,
  tags,
  updateTime,
  featured,
  onClick,
}: VideoCardProps) {
  const [imgError, setImgError] = useState(false);

  return (
    <div
      className="group cursor-pointer"
      onClick={() => onClick(id)}
      data-product-shop=""
    >
      <div className={`relative overflow-hidden rounded-xl mb-3 ${featured ? 'aspect-[16/7] md:aspect-[16/5]' : 'aspect-video'}`}>
        {!imgError ? (
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="w-full h-full bg-background-200 flex items-center justify-center">
            <i className="ri-image-line text-foreground-400 text-3xl"></i>
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
        <div className="absolute top-3 right-3">
          <span className="px-2 py-1 bg-black/70 backdrop-blur-sm text-white text-xs font-label rounded-md">
            {duration}
          </span>
        </div>
        <div className="absolute top-3 left-3">
          <span className="px-2 py-1 bg-accent-500 text-background-50 text-xs font-bold font-label rounded-md flex items-center gap-1">
            <i className="ri-star-fill text-[10px]"></i>
            {rating}
          </span>
        </div>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-14 h-14 rounded-full bg-white/90 flex items-center justify-center">
            <i className="ri-play-fill text-primary-500 text-2xl ml-0.5"></i>
          </div>
        </div>
        {featured && (
          <div className="absolute bottom-3 left-3">
            <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-[10px] font-medium rounded-full">
              推荐
            </span>
          </div>
        )}
      </div>

      <div>
        <h3 className={`font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1 ${featured ? 'text-lg' : 'text-sm'}`}>
          {title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5 flex-wrap">
          <span className="text-xs text-foreground-500 bg-background-100 px-2 py-0.5 rounded-md">
            {categoryNames[category] || category}
          </span>
          <span className="text-xs text-foreground-400">{updateTime} 更新</span>
        </div>
        <div className="flex items-center gap-1 mt-2 flex-wrap">
          {tags.slice(0, 3).map((tag) => (
            <span key={tag} className="text-[10px] text-foreground-500 bg-secondary-100 px-1.5 py-0.5 rounded">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

export { categoryNames };